import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { computed } from '@ember/object';

import { SheetObject } from 'cio/utils/google-sheets';
import { modelApiAction } from 'cio/utils/model-api-actions';
import { SignResponse } from 'cio/utils/uploads';

export type CollectionUpdateType =
  | 'name'
  | 'clear_error'
  | 'description'
  | 's3_import'
  | 'sheet'
  | 'displayed_attributes';

export default class CollectionModel extends Model {
  @attr('number') bytes!: number;
  @attr('number') createdAt!: number;
  @attr('string') description!: string;
  @attr('array', { defaultValue: () => [] }) displayedAttributes!: string[];
  @attr('string') filename!: string;
  @attr('string') importError!: string;
  @attr('boolean') importing!: boolean;
  @attr('boolean') inUse!: boolean;
  @attr('string') name!: string;
  @attr('number') rows!: number;
  @attr('string') s3Import!: string;
  @attr('array', { defaultValue: () => [] }) schema!: string[];
  @attr('number') updatedAt!: number;
  @attr('string') updateType!: CollectionUpdateType;
  @attr('string') url!: string;

  @attr('camel-case') sheet!: SheetObject;

  @computed('importing', 'importError', 'rows')
  get importIsInvalid() {
    return !this.importing && this.importError && this.rows === 0;
  }

  sign = modelApiAction<{ name: string; type: string; size: string }, SignResponse & Record<string, any>>({
    path: 'sign',
    type: 'POST',
    collection: true,
  });

  resetUpdateType() {
    this.set('updateType', null);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    collection: CollectionModel;
  }
}
